export default {
    brand_name: '灵犀',
    employURL: '', // 使用协议
    privacyURL: '', // 隐私协议
    baseYM: 'yd-out.jmkjsh.com',
    baseURL: 'https://yd-out.jmkjsh.com',
    baseURLFile: 'https://convert-test.shanghaijimu.com',
    baseURLWPS: 'https://wps.shanghaijimu.com',
    wss: 'wss:/yd-out.jmkjsh.com/ws/tts'
};
